import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/customer')({
  beforeLoad: requireRole(['customer']),
  component: Outlet,
})
